import { Col, Row, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
// import { URL } from "@/Redux/common/url";
import { Button, Modal } from "react-bootstrap";
import ImageUploading from "react-images-uploading";
import { allapiAction } from "../../Redux/common/action";
import imageCompression from "browser-image-compression";
import { URL } from "../../Redux/common/url";
import KycCard from "./KycCard";
import "./KycCard.css";

// import { allapiAction } from "@/Redux/common/action";
function BankBox() {
  const get_vendor_profiles = useSelector((state) =>
    state.allapi.get_vendor_profiles ? state.allapi.get_vendor_profiles : {}
  );

  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = () => {
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
    }, 5000);
  };



  const [show, setShow] = useState(false);
  const [userBuss, setuserBuss] = useState({});

  const dispatch = useDispatch();

  console.log(get_vendor_profiles);

  const hendleChangerole = (e) => {
    const { name, value } = e.target;
    setuserBuss({ ...userBuss, [name]: value });
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  useEffect(() => {
    if (get_vendor_profiles) {
      // URL.API_BASE_URL + get_vendor_profiles?.sellerProfile

      setuserBuss(get_vendor_profiles?.kyc_id);
      // setImages([
      //   { data_url: URL.API_BASE_URL + get_vendor_profiles?.sellerProfile },
      // ]);
      if (get_vendor_profiles?.kyc_id?.aadharfrontImage) {
        setImages1([
          {
            data_url:
              URL.API_BASE_URL + get_vendor_profiles?.kyc_id?.aadharfrontImage,
          },
        ]);
      }
      if (get_vendor_profiles?.kyc_id?.aadharbacktImage) {
        setImages2([
          {
            data_url:
              URL.API_BASE_URL + get_vendor_profiles?.kyc_id?.aadharbacktImage,
          },
        ]);
      }
      if (get_vendor_profiles?.kyc_id?.pancardImage) {
        setImages3([
          {
            data_url:
              URL.API_BASE_URL + get_vendor_profiles?.kyc_id?.pancardImage,
          },
        ]);
      }
    }
  }, [get_vendor_profiles]);

  console.log(get_vendor_profiles);

  const get_setting = useSelector((state) =>
    state.allapi.get_setting ? state.allapi.get_setting : {}
  );

  const [images, setImages] = React.useState([]);
  const maxNumber = 1;

  const onChange = async (imageList, addUpdateIndex) => {
    // data for submit
    if (imageList.length > 0) {
      const options = {
        maxSizeMB: 1, // Max 1MB
        maxWidthOrHeight: 800, // Max width/height
        useWebWorker: true, // Faster processing
      };
      const compressedFile = await imageCompression(
        imageList[0]?.file,
        options
      );
      imageList[0].newfile = compressedFile;
    }
    setImages(imageList);
  };

  const [images1, setImages1] = React.useState([]);

  const onChange1 = async (imageList, addUpdateIndex) => {
    // data for submit

    if (imageList.length > 0) {
      const options = {
        maxSizeMB: 1, // Max 1MB
        maxWidthOrHeight: 800, // Max width/height
        useWebWorker: true, // Faster processing
      };
      const compressedFile = await imageCompression(
        imageList[0]?.file,
        options
      );
      imageList[0].newfile = compressedFile;
    }
    setImages1(imageList);
  };
  const [images2, setImages2] = React.useState([]);

  const onChange2 = async (imageList, addUpdateIndex) => {
    // data for submit
    if (imageList.length > 0) {
      const options = {
        maxSizeMB: 1, // Max 1MB
        maxWidthOrHeight: 800, // Max width/height
        useWebWorker: true, // Faster processing
      };
      const compressedFile = await imageCompression(
        imageList[0]?.file,
        options
      );
      imageList[0].newfile = compressedFile;
    }
    setImages2(imageList);
  };
  const [imagesPro, setImagesPro] = React.useState([]);

  const onChangePro = async (imageList, addUpdateIndex) => {
    // data for submit
    if (imageList.length > 0) {
      const options = {
        maxSizeMB: 1, // Max 1MB
        maxWidthOrHeight: 800, // Max width/height
        useWebWorker: true, // Faster processing
      };
      const compressedFile = await imageCompression(
        imageList[0]?.file,
        options
      );
      imageList[0].newfile = compressedFile;
    }
    setImagesPro(imageList);
  };
  const [images3, setImages3] = React.useState([]);

  const onChange3 = async (imageList, addUpdateIndex) => {
    // data for submit
    if (imageList.length > 0) {
      const options = {
        maxSizeMB: 1, // Max 1MB
        maxWidthOrHeight: 800, // Max width/height
        useWebWorker: true, // Faster processing
      };
      const compressedFile = await imageCompression(
        imageList[0]?.file,
        options
      );
      imageList[0].newfile = compressedFile;
    }
    setImages3(imageList);
  };

  const submitProduct = () => {
    const data = new FormData();
    // pancardImage
    // aadharfrontImage
    // aadharbacktImage

    if (images1[0]?.file) {
      // roledata?.role_name
      // data.append("aadharfrontImage", images1[0]?.file);
      data.append(
        "aadharfrontImage",
        images1[0]?.newfile,
        images1[0]?.file?.name
      );
    }
    if (images2[0]?.file) {
      // roledata?.role_name
      // data.append("aadharbacktImage", images2[0]?.file);
      data.append(
        "aadharbacktImage",
        images2[0]?.newfile,
        images2[0]?.file?.name
      );
    }
    if (images3[0]?.file) {
      // roledata?.role_name
      // data.append("pancardImage", images3[0]?.file);
      data.append("pancardImage", images3[0]?.newfile, images3[0]?.file?.name);
    }
    data.append("pan_card", userBuss?.pan_card);
    data.append("aadhar_card", userBuss?.aadhar_card);
    data.append("ifsc", userBuss?.ifsc);
    data.append("acc_no", userBuss?.acc_no);
    data.append("bank_name", userBuss?.bank_name);
    data.append("branch_name", userBuss?.branch_name);
    data.append("acc_holder", userBuss?.acc_holder);
    dispatch(allapiAction.kycUpdate(data));
    // dispatch(
    //   allapiAction.kycUpdate({
    //     acc_holder: userBuss?.acc_holder,
    //     aadhar_card: userBuss?.aadhar_card,
    //     pan_card: userBuss?.pan_card,
    //     ifsc: userBuss?.ifsc,
    //     acc_no: userBuss?.acc_no,
    //     bank_name: userBuss?.bank_name,
    //     branch_name: userBuss?.branch_name,
    //   })
    // );

    setShow(false);
  };
  return (
    <Row gutter={[0, 20]}>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Update</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {" "}
          <div className="card mx-auto ">
            {/* {!showOtpBox ? ( */}
            <div className="card-body">
              {/* <h4 className="card-title mb-4">Feature Image</h4> */}

              <div className="mb-3">
                <label className="form-label">Account holder</label>
                <input
                  name="acc_holder"
                  className="form-control"
                  placeholder="Enter Account holder"
                  type="text"
                  value={userBuss?.acc_holder}
                  onChange={(e) => {
                    hendleChangerole(e);
                  }}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Bank name</label>
                <input
                  name="bank_name"
                  className="form-control"
                  placeholder="Enter bank name"
                  type="text"
                  value={userBuss?.bank_name}
                  onChange={(e) => {
                    hendleChangerole(e);
                  }}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">branch name</label>
                <input
                  name="branch_name"
                  className="form-control"
                  placeholder="Enter branch name"
                  type="text"
                  value={userBuss?.branch_name}
                  onChange={(e) => {
                    hendleChangerole(e);
                  }}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Enter account</label>
                <input
                  name="acc_no"
                  className="form-control"
                  placeholder="Enter account"
                  type="text"
                  value={userBuss?.acc_no}
                  onChange={(e) => {
                    hendleChangerole(e);
                  }}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">IFSC</label>
                <input
                  name="ifsc"
                  className="form-control"
                  placeholder="Enter IFSC"
                  type="text"
                  value={userBuss?.ifsc}
                  onChange={(e) => {
                    hendleChangerole(e);
                  }}
                />
              </div>
              <div className="mb-3">
                <label className="form-label"> Aadhar Card No.</label>
                <input
                  name="aadhar_card"
                  className="form-control"
                  placeholder="Enter aadhar card"
                  type="text"
                  value={userBuss?.aadhar_card}
                  onChange={(e) => {
                    hendleChangerole(e);
                  }}
                />
              </div>

              <div className="mb-3">
                <label className="form-label"> Addhar Front Photo</label>
                <ImageUploading
                  // multiple
                  value={images1}
                  onChange={onChange1}
                  maxNumber={maxNumber}
                  dataURLKey="data_url"
                  acceptType={["png", "jpeg", "jpg", "webp"]}
                >
                  {({
                    imageList,
                    onImageUpload,
                    onImageRemoveAll,
                    onImageUpdate,
                    onImageRemove,
                    isDragging,
                    dragProps,
                  }) => (
                    // write your building UI
                    <div className="upload__image-wrapper">
                      <button
                        className="btn btn-primary btn-sm rounded"
                        style={isDragging ? { color: "red" } : undefined}
                        onClick={onImageUpload}
                        {...dragProps}
                      >
                        Click or Drop here
                      </button>
                      &nbsp;
                      {/* <button
                          className="btn btn-primary btn-sm rounded"
                          onClick={onImageRemoveAll}
                        >
                          Remove all images
                        </button> */}
                      {imageList.map((image, index) => (
                        <div key={index} className="image-item">
                          <img src={image["data_url"]} alt="" width="100" />
                          <div className="image-item__btn-wrapper">
                            <button
                              className="btn btn-primary btn-sm rounded mb-2"
                              onClick={() => onImageUpdate(index)}
                            >
                              Update
                            </button>
                            <button
                              className="btn btn-primary btn-sm rounded"
                              onClick={() => onImageRemove(index)}
                            >
                              Remove
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </ImageUploading>
              </div>
              <div className="mb-3">
                <label className="form-label"> Aadhar back Photo</label>
                <ImageUploading
                  // multiple
                  value={images2}
                  onChange={onChange2}
                  maxNumber={maxNumber}
                  dataURLKey="data_url"
                  acceptType={["png", "jpeg", "jpg", "webp"]}
                >
                  {({
                    imageList,
                    onImageUpload,
                    onImageRemoveAll,
                    onImageUpdate,
                    onImageRemove,
                    isDragging,
                    dragProps,
                  }) => (
                    // write your building UI
                    <div className="upload__image-wrapper">
                      <button
                        className="btn btn-primary btn-sm rounded"
                        style={isDragging ? { color: "red" } : undefined}
                        onClick={onImageUpload}
                        {...dragProps}
                      >
                        Click or Drop here
                      </button>
                      &nbsp;
                      {/* <button
                          className="btn btn-primary btn-sm rounded"
                          onClick={onImageRemoveAll}
                        >
                          Remove all images
                        </button> */}
                      {imageList.map((image, index) => (
                        <div key={index} className="image-item">
                          <img src={image["data_url"]} alt="" width="100" />
                          <div className="image-item__btn-wrapper">
                            <button
                              className="btn btn-primary btn-sm rounded mb-2"
                              onClick={() => onImageUpdate(index)}
                            >
                              Update
                            </button>
                            <button
                              className="btn btn-primary btn-sm rounded"
                              onClick={() => onImageRemove(index)}
                            >
                              Remove
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </ImageUploading>
              </div>
              <div className="mb-3">
                <label className="form-label">pan card</label>
                <input
                  name="pan_card"
                  className="form-control"
                  placeholder="Enter pan card"
                  type="text"
                  value={userBuss?.pan_card}
                  onChange={(e) => {
                    hendleChangerole(e);
                  }}
                />
              </div>
              <div className="mb-3">
                <label className="form-label"> Pan Card Photo</label>
                <ImageUploading
                  // multiple
                  value={images3}
                  onChange={onChange3}
                  maxNumber={maxNumber}
                  dataURLKey="data_url"
                  acceptType={["png", "jpeg", "jpg", "webp"]}
                >
                  {({
                    imageList,
                    onImageUpload,
                    onImageRemoveAll,
                    onImageUpdate,
                    onImageRemove,
                    isDragging,
                    dragProps,
                  }) => (
                    // write your building UI
                    <div className="upload__image-wrapper">
                      <button
                        className="btn btn-primary btn-sm rounded"
                        style={isDragging ? { color: "red" } : undefined}
                        onClick={onImageUpload}
                        {...dragProps}
                      >
                        Click or Drop here
                      </button>
                      &nbsp;
                      {/* <button
                          className="btn btn-primary btn-sm rounded"
                          onClick={onImageRemoveAll}
                        >
                          Remove all images
                        </button> */}
                      {imageList.map((image, index) => (
                        <div key={index} className="image-item">
                          <img src={image["data_url"]} alt="" width="100" />
                          <div className="image-item__btn-wrapper">
                            <button
                              className="btn btn-primary btn-sm rounded mb-2"
                              onClick={() => onImageUpdate(index)}
                            >
                              Update
                            </button>
                            <button
                              className="btn btn-primary btn-sm rounded"
                              onClick={() => onImageRemove(index)}
                            >
                              Remove
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </ImageUploading>
              </div>
            </div>
          </div>
        </Modal.Body>

        {/* {!showOtpBox ? ( */}
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>



          {/* <Button
            variant="primary"
            onClick={() => {
              submitProduct();
            }}
          >
            Submit
          </Button> */}

          <Button
            variant="primary"
            onClick={() => {
              submitProduct(); // API / Redux submit
              handleSubmit();  // KYC animation + particles
            }}
          >
            Submit
          </Button>



        </Modal.Footer>
        {/* ) : (
          <Modal.Footer>
            <Button
              variant="primary"
              onClick={() => {
                submitChangeVerify2();
              }}
            >
              Verify
            </Button>
          </Modal.Footer>
        )} */}
      </Modal>
      <Col lg={24} md={24} sm={24} xs={24}>
        <div
          className="flex1 dashboardBoxShad cursor-pointer"
        //   onClick={() => navigate("/users")}
        >
          <div className="row border-bottom pt-5 pb-10">
            <div className="col-6 fw-bold">Bank Information</div>
            <div className="col-6">
              {" "}
              {/* <span className="jop_btn ant-tooltip-open" onClick={handleShow}>
                Update Profile Image
              </span> */}
              <div className="flex1 flex justify-content-end align-items-center">
                <Tooltip title="Update">
                  <span className="jop_btn" onClick={handleShow}>
                    Update
                  </span>
                </Tooltip>
              </div>
            </div>
          </div>



          <div className="row justify-content-center align-items-center">
          {/* <div className="row justify-content-center align-items-center" style={{ background: "radial-gradient(circle at top, #0f172a, #020617)" }}> */}
            {/* <div className="col-12 ">
              <div style={{ width: "180px" }}>
               
                <span className="jop_btn ant-tooltip-open" onClick={handleShow}>
                  Update Profile Image
                </span>
                
              </div>
            </div>
            <div className="col-3">
              <div style={{ width: "100px" }}>
                <img
                  src={URL.API_BASE_URL + get_vendor_profiles?.sellerProfile}
                  alt=""
                  style={{ width: "100%" }}
                />
          
              </div>
            </div> */}
            {/* <div className="col-9">
              <p>name : {get_vendor_profiles?.fullName}</p>
              <p>Bussiness Name : {get_vendor_profiles?.displayName}</p>
              <p>Phone : {get_vendor_profiles?.phone}</p>
              <p>
                Address : {get_vendor_profiles?.city},
                {get_vendor_profiles?.state},{get_vendor_profiles?.zip}
              </p>
              
            </div> */}
            <div className="col-md-8 bankdetails d-none">
              <div
                class="card bank-info-card bg-bottom bg-contain bg-img"
              // style={{
              //   backgroundImage:
              //     "url(https://casandeepsharma.in.net/public/assets/back-end/img/bank-info-card-bg.png)",
              // }}
              >
                <div class="border-bottom p-3">
                  <h3 class="mb-0 fw-semibold">
                    Holder Name :{" "}
                    <strong>
                      {" "}
                      {get_vendor_profiles?.kyc_id?.acc_holder
                        ? get_vendor_profiles?.kyc_id?.acc_holder
                        : " No Data found"}{" "}
                    </strong>
                  </h3>
                </div>

                <div class="card-body position-relative">
                  <img
                    class="bank-card-img"
                    width="78"
                    src="https://casandeepsharma.in.net/public/assets/back-end/img/bank-card.png"
                    alt=""
                  />

                  <ul class="list-unstyled d-flex flex-column gap-4">
                    <li>
                      <h3 class="mb-2">Bank Name :</h3>
                      <div>
                        {get_vendor_profiles?.kyc_id?.bank_name
                          ? get_vendor_profiles?.kyc_id?.bank_name
                          : " No Data found"}
                      </div>
                    </li>
                    <li>
                      <h3 class="mb-2">Branch Name :</h3>
                      <div>
                        {get_vendor_profiles?.kyc_id?.branch_name
                          ? get_vendor_profiles?.kyc_id?.branch_name
                          : " No Data found"}
                      </div>
                    </li>
                    <li>
                      <h3 class="mb-2">Account Number : </h3>
                      <div>
                        {get_vendor_profiles?.kyc_id?.acc_no
                          ? get_vendor_profiles?.kyc_id?.acc_no
                          : " No Data found"}
                      </div>
                    </li>
                    <li>
                      <h3 class="mb-2">IFSC : </h3>
                      <div>
                        {get_vendor_profiles?.kyc_id?.ifsc
                          ? get_vendor_profiles?.kyc_id?.ifsc
                          : " No Data found"}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-md-8 bankdetails mt-40 d-none">
              <div
                class="card bank-info-card bg-bottom bg-contain bg-img"
              // style={{
              //   backgroundImage:
              //     "url(https://casandeepsharma.in.net/public/assets/back-end/img/bank-info-card-bg.png)",
              // }}
              >
                <div class="border-bottom p-3">
                  <h4 class="mb-0 fw-semibold">
                    Addhar :{" "}
                    <strong>
                      {" "}
                      {get_vendor_profiles?.kyc_id?.aadhar_card
                        ? get_vendor_profiles?.kyc_id?.aadhar_card
                        : " No Data found"}{" "}
                    </strong>
                  </h4>
                </div>

                <div class="card-body position-relative">
                  <img
                    class="bank-card-img"
                    width="78"
                    src="https://casandeepsharma.in.net/public/assets/back-end/img/bank-card.png"
                    alt=""
                  />

                  <ul class="list-unstyled d-flex flex-column gap-4">
                    <li>
                      <h3 class="mb-2">Front Image :</h3>
                      <div>
                        <img
                          src={
                            URL.API_BASE_URL +
                            get_vendor_profiles?.kyc_id?.aadharfrontImage
                          }
                          alt=""
                          style={{ width: "100%" }}
                        />
                        {/* {get_vendor_profiles?.kyc_id?.bank_name
                          ? get_vendor_profiles?.kyc_id?.bank_name
                          : " No Data found"} */}
                      </div>
                    </li>
                    <li>
                      <h3 class="mb-2">Addhar Card Back :</h3>
                      <div>
                        <img
                          src={
                            URL.API_BASE_URL +
                            get_vendor_profiles?.kyc_id?.aadharbacktImage
                          }
                          alt=""
                          style={{ width: "100%" }}
                        />
                      </div>
                    </li>
                    <li>
                      <h3 class="mb-2">Pan Card : </h3>
                      <div>
                        {get_vendor_profiles?.kyc_id?.pan_card
                          ? get_vendor_profiles?.kyc_id?.pan_card
                          : " No Data found"}
                      </div>
                    </li>
                    <li>
                      <h3 class="mb-2">Pan card Image : </h3>
                      <div>
                        <img
                          src={
                            URL.API_BASE_URL +
                            get_vendor_profiles?.kyc_id?.pancardImage
                          }
                          alt=""
                          style={{ width: "100%" }}
                        />
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>



            {/* SUCCESS ANIMATION */}
            {submitted && (
              <div className="kyc-success">
                <div className="particles">
                  {Array.from({ length: 30 }).map((_, i) => (
                    <span key={i} className="particle"></span>
                  ))}
                </div>

                <div className="success-box">
                  <div className="checkmark">✔</div>
                  <h2 className="text-white">KYC Submitted Successfully</h2>
                  <p className="text-white">
                    Please wait while we verify your documents
                  </p>
                </div>
              </div>
            )}


            <KycCard kycData={get_vendor_profiles?.kyc_id} />

          </div>
        </div>
      </Col>


    </Row>
  );
}

export default BankBox;
